export const dishes = ['4133', '4130', '4132', '991', '2891', '507', '3093', '3472', '2299', '3295', '904'];
